import { render, staticRenderFns } from "./MyStoreLists.vue?vue&type=template&id=31248024&scoped=true&"
import script from "./MyStoreLists.vue?vue&type=script&lang=js&"
export * from "./MyStoreLists.vue?vue&type=script&lang=js&"
import style0 from "./MyStoreLists.vue?vue&type=style&index=0&id=31248024&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31248024",
  null
  
)

export default component.exports